
















































































  import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
  import { store, StoreState } from "../../store";
  import VueCsvDownloader from 'vue-csv-downloader';
  import {RotateSquare2} from 'vue-loading-spinner';
  import VueElementLoading from 'vue-element-loading';  
  import { mapState } from "vuex";

  @Component({
      components: {
      VueCsvDownloader,
       RotateSquare2,
       VueElementLoading,  
      },
      computed: {
        ...mapState({
        })
      },
      props: ['isbulkimportopen'],
     created() {
      console.log('created hook called');
      console.log('isbulkimport here in',(this as any).isbulkimportopen);
      this.$data.isBulkImportingOpen = (this as any).isbulkimportopen
    } ,
    mounted:function(){
      
      //this.$data.isBulkImportingOpen = (this as any).isbulkimportopen
      this.$data.validation_msg=true;
        this.loadTextFromFile();
      },
    })
  export default class BulkImporteamMember extends Vue {
        
    data() {
      return {
        text: "",
        data: [{} ],
        
        fields: [ 'First Name','Last Name','Mobile','Work','Home','Company','Address','Email','Customer ID','Type(Personal / Shared)'],
        user_list: [],
        submitted: false,
        sample:[],
        loading:false,
        succus_msg:'',
        file_name:'',
        validation_msg:false,
        payload:{}  ,
       file_valid:false,
       fname_valid:false,
       lname_valid:false,
       phone_valid:false,
       phoneval_valid:false,
       typevalid:false,
       typegvalid:false,
       ismobileemailexist:false,
       isBulkImportingOpen:true,
       errornamelist:[]
      };
    }


bulkimportclose()
{
  debugger
  let ele = document.getElementById('bulkimport');
  ele.classList.remove('importbgactive');
  //this.$data.isBulkImportingOpen=false;
}

   loadTextFromFile(e) {
    var fileUpload = document.getElementById("fileUpload");
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv|.txt)$/;
    this.$data.file_name=this.$data.succus_msg=''; 
      //  var hj=  regex.test(e.target.value.toLowerCase());
      //  var filetype=files ?  e.target.files[0].type: '' ;
      //   var iscsv= filetype==="text/csv" || filetype=== "application/vnd.ms-excel";
      var filename= this.$data.file_name= e.target.files[0].name;
      var fileExt = filename.split('.').pop();
      var iscsv= fileExt==="csv";
       const files = e.target.files;  
          if(iscsv) {  

            for (let i = 0, f; f = files[i]; i++) {
                var reader = new FileReader();
                reader.onloadend = function(output){
                  var self = this;  
                  var table = document.createElement("table");
                    var rows = output.target.result.split("\n");
                   var data=rows;
                   rows= data.filter((data) => !data.startsWith(",,,,,,,"));
                    var cells = rows[0].split(',');
                    if(rows.length==1 || rows[1]== ""){
                      alert('Uploaded file is empty , Please fill out the fields');
                       this.$data.file_valid=true;
                      return 
                    }
                    var fields=this.$data.fields;
                    this.$data.file_valid=false;
                    this.$data.fname_valid=false;
                    this.$data.lname_valid=false;
                    this.$data.phone_valid=false;
                    this.$data.phoneval_valid=false;
                    this.$data.filetemp_valid=false;
                    this.$data.emailval_valid=false; 
                    this.$data.typevalid = false;  
                    this.$data.typegvalid = false; 
                    if( (cells[0].toLowerCase().trim()!= fields[0].toLowerCase()) || (cells[1].toLowerCase().trim()!= fields[1].toLowerCase()) 
                     || (cells[2].toLowerCase().trim()!= fields[2].toLowerCase()) || (cells[3].toLowerCase().trim()!= fields[3].toLowerCase()) 
                     || (cells[4].toLowerCase().trim()!= fields[4].toLowerCase()) || (cells[5].toLowerCase().trim()!= fields[5].toLowerCase()) 
                     || (cells[6].toLowerCase().trim()!= fields[6].toLowerCase()) || (cells[7].toLowerCase().trim()!= fields[7].toLowerCase()) 
                     || (cells[8].toLowerCase().trim()!= fields[8].toLowerCase()) || (cells[9].toLowerCase().trim()!= fields[9].toLowerCase()))
                    {  
                      alert('Invalid template file, download the sample template and try again.');
                       this.$data.filetemp_valid=true;
                      return;
                    }
                  
                  var user_list=[]; 
                  let last_type = "personal";
                  for (var i = 1; i < rows.length; i++) 
                  {
                     
                    if(rows[i]!=""){  


                      let cells = [];
                        var cells_part = rows[i].split('",');
                        cells_part.forEach(element => {
                          let c_part = "";
                          if(element.indexOf('\"') > -1)
                          {
                            c_part = element.split('",');

                          }
                          else
                          {
                            c_part = element.split(",")
                          }
                          cells = cells.concat(c_part)

                          
                        });

                        for(let i = 0; i < cells.length; i++)
                        {
                          cells[i] = cells[i].replaceAll('"','');
                          cells[i] = cells[i].replaceAll('\\','');
                        }

                    
                        var homecell = cells[4].trim();
                        if(cells[0]=="")
                        {
                          alert("Please enter first name");
                          this.$data.fname_valid=true;
                            return;
                        }
                        // Last Name
                          //if(!lname)
                          if(cells[1]=="")
                        {
                          alert("Please enter last name");
                          this.$data.lname_valid=true;
                            return;
                        }
                      
                        if((cells[2]== "") && (cells[3] == "") && (homecell == ""))
                        {                        
                          alert("Please enter any of the phone number");
                            this.$data.phone_valid=true;
                          return;
                        
                        }
                          let mobilevalidate =  cells[2] ? !(this.validatePhoneNumber(cells[2]) != 'Invalid number' ): (cells[3]) || (homecell) ? false : true; 
                          let homevalidate = homecell ? !(this.validatePhoneNumber(homecell) != 'Invalid number' ): (cells[2])|| (cells[3]) ? false : true; 
                          let workvalidate = cells[3] ? !(this.validatePhoneNumber(cells[3]) != 'Invalid number' ): (cells[2]) || (homecell)? false : true; 
                          if(mobilevalidate ||homevalidate || workvalidate)  
                          {
                          alert("Please enter valid phone number");
                          this.$data.phoneval_valid=true;
                          return;
                          }
                      
                        // Test email address
                          if(cells[7]!=""){
                          if(!this.validateEmail(cells[7]))  
                          {
                              alert("Please enter a valid email address");  
                              this.$data.emailval_valid=true;                         
                              return;
                          }                      
                          }
                          last_type = cells[9].replaceAll("\\r",'').toLowerCase().trim();
                          cells[9] = cells[9].trim();
                          if(cells[9]=="")
                          {
                            alert("Please enter Type of the contact");
                            this.$data.typevalid=true;
                            return;
                          }
                            if(last_type!='personal' && last_type!= 'shared')
                          {
                             alert("Please enter the valid type of the contact");
                            this.$data.typegvalid=true;
                            return;
                          }
                        
                          
                          

                            user_list.push({
                            firstName        :  cells[0],
                            lastName         :  cells[1],
                            mobile           : cells[2],
                            work             : [{ work: cells[3], extension: '' }],
                            home             : cells[4],
                            companyName      :  cells[5],                         
                            address          :  cells[6],
                            email            :  cells[7],
                            custermerid     :  cells[8],
                            last_type       : cells[9]
                          });
                    
                    }                  
                         //}
                         else{
                            rows.splice(i, 1);  
                         }
                  }
                   this.$data.user_list=user_list;
                  return false;
                }.bind(this);
                reader.readAsText(f);
            }
          }
           else {
            alert("Please upload the file");  
        }
    }

validatePhoneNumber(phoneNumber: any) {
    if(!phoneNumber) return true;
     if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            } 
            if(phoneNumber.length != 10) return "Invalid number";      
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
              this.$data.Number_status = false;
                   // console.log("The phone number " + phoneNumber + " could not be parsed");
                return "Invalid number";
            }           
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }

  async submit_feile(e) { 
      if(this.$data.filetemp_valid==true)
      {
        alert('Invalid template file, download the sample template and try again.');
      }
      if(this.$data.fname_valid == true)
      {
         alert("Please enter first name");
      }
      if(this.$data.lname_valid == true)
      {
        alert("Please enter last name");
      }
      if(this.$data.phone_valid == true)
      {
        alert("Please enter any of the phone number");
      }
       if(this.$data.phoneval_valid == true)
      {
        alert("Please enter valid phone number");
      }
      if(this.$data.file_valid == true)
      {
        alert('Uploaded file is empty , Please fill out the fields');
      }
      if(this.$data.emailval_valid== true)
      {
        alert("Please enter a valid email address");  
      }
       if(this.$data.typevalid== true)
      {
        alert("Please enter a type of the contact");  
      }
       if(this.$data.typegvalid== true)
      {
        alert("Please enter a valid type of the contact");  
      }
       if(this.$data.file_name=='')
       {alert('Please upload the file')}
     
    //  return;
      if(this.$data.user_list.length>0){
           this.$data.isBulkImportingOpen=false;
          for (var i = 0; i < this.$data.user_list.length; i++) {
              
            
                var Newcontact_data:any= {
                fname        :  this.$data.user_list[i].firstName,
                lname        :  this.$data.user_list[i].lastName,
                companyname  :  this.$data.user_list[i].companyName,
               // numbers      :{ main: [null], mobile: {number: user_list.mobile ? user_list.mobile : '',sms_enabled: user_list.mobile ? true : false}, ext:""},
                work         :  this.$data.user_list[i].work,
              //  work         :  worknum,
                mobile       : this.$data.user_list[i].mobile ? this.$data.user_list[i].mobile : '',  
                extension    :  this.$data.user_list[i].extension,                  
                custermerid  :  this.$data.user_list[i].custermerid,
                address      :  this.$data.user_list[i].address,
                email        :  this.$data.user_list[i].email,
                home         :  this.$data.user_list[i].home,
               // tags1        :  [],
               taglist     :  [],           
              allows_texts:true,
              notes:[],
              pvt_type:"contact",
              imageUrl:"",
             // taglist:[],
             // tags1:[],
              pvt_cont:false,
              
              select:true,
              tags:[],
              private:(this.$data.user_list[i].last_type).toLowerCase() == 'personal'? true:false,
              Favoritecontact:[]
            } 
            
              //  Newcontact_data.taglist = [];
              //  Newcontact_data.tags1 = [];
              this.$data.loading=true;
                await this.$store.dispatch('addCaller', Newcontact_data)
                .then(r => {            
                  this.$data.loading=false;               
                    console.log(r.data);
                    if(r && r.data && r.data.status==403)
                    {
                    this.$data.ismobileemailexist = true;                
                  this.$data.errornamelist.push({'firstname':r.data.firstname,'lastname':r.data.lastname}) 
                                  
                    }
                    else{                        
                    // 
                      let ele = document.getElementById('bulkimport');
                      ele.classList.remove('importbgactive');
                      
                    
                    }
                })
                .catch(() => {});   

                if( (i==(this.$data.user_list.length-1)) && (this.$data.errornamelist.length>0) ) {
                    this.$emit('bulkimportevent' , 'refresh',true);
                }
                if( (i==(this.$data.user_list.length-1)) && (this.$data.errornamelist.length==0) ) {
                    this.$emit('bulkimportevent' , 'refresh');
                }
          }
        }


    //   if(typeof this.$data.user_list['shared'] != 'undefined' && 
    //   this.$data.user_list['shared'].length>0){
    //     let shared_arr = [];
    //     let workshared =[];
    //       for (var i = 0; i < this.$data.user_list['shared'].length; i++) {
    //         let user_list = this.$data.user_list['shared'][i];
    //         //  if(user_list.work.length > 0)
    //         //   {
    //         //     for(var j=0;j<user_list.work.length;j++){
                  
    //         //        workshared.push({work:user_list.work[j].work})             
    //         //   }
    //         //   }
    //         //   else{
    //         //      workshared = [];
    //         //   }

    //         var newcontact_data:any = {
    //           first_name: user_list.firstName,
    //           last_name: user_list.lastName,
    //           compny_name: user_list.companyName,
    //           numbers:{ main: [null], mobile: {number: user_list.mobile ? user_list.mobile : '',sms_enabled: user_list.mobile ? true : false}, ext:""},
    //           work :user_list.work,
    //           // work: workshared,
    //           home: user_list.home,
    //           address: user_list.address,
    //           email:[user_list.email],
    //           custermerid  :  user_list.custermerid,
    //           allows_texts:true,
    //           notes:[],
    //           pvt_type:"contact",
    //           imageUrl:"",
    //          // taglist:[],
    //          // tags1:[],
    //           pvt_cont:false,
    //           mobile: user_list.mobile ? user_list.mobile : '',
    //           select:true,
    //           tags:[],
    //           private:false,
    //           Favoritecontact:[]
    //         }           
    //         shared_arr.push(newcontact_data)
              
    //       }
    //      // newcontact_data.taglist = [];
    //       //  newcontact_data.tags1 = [];
    //       this.$store.dispatch('addtoshareContac', shared_arr)
    //         .then(r => {                                 
    //           this.$emit('bulkimportevent' , 'refresh');
    //           let ele = document.getElementById('bulkimport');
    //             ele.classList.remove('importbgactive')
    //         })
    //         .catch(() => {}); 
    //   }
    //  }
    }

     clearError(){
      this.$data.file_name=this.$data.succus_msg='';
    }


    validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
           mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(mob_number.length === 10) {
           mob_number = `+1${mob_number}`;
         }
        else {
            mob_number = `+${mob_number}`;
        }
        return mob_number;
    }

    validateEmail(email: any) {
        //Breakdown of this Regex can be found here:
        //https://www.w3resource.com/javascript/form/email-validation.php
        //Seems to cover most all cases.
         const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;///^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!re.test(email)) {
                this.$data.Email_status=false;
                return false;
            }
        this.$data.Email_status=true;
        return true;
    }
    
    }

